/**User Reducer Types */
export const REMOVE_USER_IDENTITY='REMOVE_USER_IDENTITY'
export const SET_USER_IDENTITY='SET_USER_IDENTITY'
export const LOADING_USER='LOADING_USER'
export const Stop_LOADING_USER='Stop_LOADING_USER'
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
export const SET_USER_TYPE='SET_USER_TYPE';
/**Ui Reducer Types */
export const SET_ERRORS='SET_ERRORS'
export const CLEAR_ERRORS='CLEAR_ERRORS'
export const ClEAR_SIGNUP_STEPPER='ClEAR_SIGNUP_STEPPER'
export const LOADING_UI='LOADING_UI'
export const STOP_LOADING_UI='STOP_LOADING_UI'
export const SET_SIGNUP_STEPPE='SET_SIGNUP_STEPPER'
export const SET_SIGGNUP_ON_INPUT_CHANGE_PH="SET_SIGGNUP_ON_INPUT_CHANGE_PH";
export const SET_SIGGNUP_ON_INPUT_CHANGE_STK="SET_SIGGNUP_ON_INPUT_CHANGE_STK";
export const RESET_SIGNUP_CURRENT_STEP='RESET_SIGNUP_CURRENT_STEP';
/**Data Reducer Types */
export const LOADING_DATA="LOADING_DATA";
export const SET_AREAS_DATA="SET_AREAS_DATA";
export const SET_USER_DRUGS_DATA='SET_USER_DRUGS_DATA';
export const SET_USER_DRUGS_REQS_RECIEVED_DATA='SET_USER_DRUGS_REQS_RECIEVED_DATA';
export const SET_USER_DRUGS_REQS_MADE_DATA='SET_USER_DRUGS_REQS_MADE_DATA';
export const STOP_LOADING_DATA='STOP_LOADING_DATA'
export const SET_ERROR_ON_FETCH_DATA='SET_ERROR_ON_FETCH_DATA'
export const UPDATE_LZ_DRG='UPDATE_LZ_DRG'
export const UPDATE_DRGS_DATA_WITH_NEWLLY_ADDED='UPDATE_DRGS_DATA_WITH_NEWLLY_ADDED';
export const UPDATE_DRGREQUEST_MODEL='UPDATE_DRGREQUEST_MODEL'

export const LOADING_SEARCH_DATA='LOADING_SEARCH_DATA'
export const Stop_LOADING_SEARCH_DATA='Stop_LOADING_SEARCH_DATA'
export const SET_ERRORS_ON_FETCH_SEARCH_DATA='SET_ERRORS_ON_FETCH_SEARCH_DATA'
export const SET_SEARCH_Q='SET_SEARCH_Q'
export const SET_SEARCH_CITYIDS='SET_SEARCH_CITYIDS'
export const SET_SEARCH_AREAIDS='SET_SEARCH_AREAIDS'
export const SET_SEARCH_VALIDBEFORE='SET_SEARCH_VALIDBEFORE'
export const SET_SEARCH_ORDERBY='SET_SEARCH_ORDERBY'
export const SET_SEARCH_PAGESIZE='SET_SEARCH_PAGESIZE'
export const SET_SEARCH_PAGENUMBER='SET_SEARCH_PAGENUMBER'
export const SET_SEARCH_PAGENUMBER_AND_PAGESIZE='SET_SEARCH_PAGENUMBER_AND_PAGESIZE'
export const UPDATE_DRGS_SEARCH_ROW_AFTER_REQUEST_ADDED='UPDATE_DRGS_SEARCH_ROW_AFTER_REQUEST_ADDED'

export const RESET_DATA_AFTERLOGOUT='RESET_DATA_AFTERLOGOUT'

export const SET_SELECTED_CITIES='SET_SELECTED_CITIES'
export const SET_SELECTED_DESTICTS='SET_SELECTED_DESTICTS'
export const SET_SEARCH_TABLE_DATA='SET_SEARCH_TABLE_DATA'
export const SET_SEARCH_FILTERED_DATA='SET_SEARCH_FILTERED_DATA'
export const SET_DATE_FILTER='SET_DATE_FILTER'
/**Data reducer types */

